import { render } from "./ViewPlace.vue?vue&type=template&id=641b0d15&ts=true"
import script from "./ViewPlace.vue?vue&type=script&lang=ts"
export * from "./ViewPlace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__